import FlickityFade from 'flickity-fade';
import FlickitySync from 'flickity-sync';

const selectors = {
  groupImage: 'data-image-filter',
  slider: '[data-product-slideshow]',
  thumbSlider: '[data-product-thumbs]',
  thumbs: '[data-slideshow-thumbnail]',
  slides: '[data-media-slide]',
};

const classes = {
  hide: 'hide',
  flickityEnable: 'flickity-enabled',
};

class GroupVariantImages {
  constructor(section) {
    this.section = section;
    this.container = section.container;
    this.slider = this.container.querySelector(selectors.slider);
    this.thumbSlider = this.container.querySelector(selectors.thumbSlider);
    this.thumbs = this.container.querySelectorAll(selectors.thumbs);
    this.slides = this.container.querySelectorAll(selectors.slides);
    this.variantImage = null;

    this.listen();
  }

  listen() {
    this.container.addEventListener('theme:variant:change', (event) => {
      if (event.detail.variant) {
        this.variantImage = event.detail.variant.featured_image;
        this.filterImages();
      }
    });
  }

  filterImages() {
    if (this.variantImage !== null && this.variantImage.alt !== null) {
      this.variantImageAlt = this.variantImage.alt.split('#')[1];
      this.showImages();
    } else {
      this.resetImages();
    }

    this.refreshSliders();
  }

  resetImages() {
    this.thumbs.forEach((thumb) => thumb.classList.remove(classes.hide));
    this.slides.forEach((slide) => slide.classList.remove(classes.hide));
  }

  showImages() {
    this.thumbs.forEach((thumb) => {
      if (thumb.getAttribute(selectors.groupImage) === '' || thumb.getAttribute(selectors.groupImage) === this.variantImageAlt) {
        thumb.classList.remove(classes.hide);
      } else {
        thumb.classList.add(classes.hide);
      }
    });

    this.slides.forEach((slide) => {
      if (slide.getAttribute(selectors.groupImage) === '' || slide.getAttribute(selectors.groupImage) === this.variantImageAlt) {
        slide.classList.remove(classes.hide);
      } else {
        slide.classList.add(classes.hide);
      }
    });
  }

  refreshSliders() {
    if (this.slider !== null) {
      if (this.slider.classList.contains(classes.flickityEnable)) {
        const slider = FlickityFade.data(this.slider);
        if (typeof slider !== 'undefined') {
          slider.reloadCells();
        }
      }
    }

    if (this.thumbSlider !== null) {
      if (this.thumbSlider.classList.contains(classes.flickityEnable)) {
        const thumbSlider = FlickitySync.data(this.thumbSlider);
        if (typeof thumbSlider !== 'undefined') {
          thumbSlider.reloadCells();
        }
      }
    }
  }
}

export {GroupVariantImages};
